module.exports = __webpack_public_path__ + "img/arrow-right-green-hover.795fd843.svg";